import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import InputField from 'components/InputField/InputField.jsx'
import SelectField from 'components/InputField/SelectField';

const labels = {
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  email_confirmation: 'Confirm email',
  password: 'Password',
  user_type: 'I am a',
  imc: 'GMC Number',
  registration: 'Registration Number'
}

const roles = [
  { value: 'gp', label: 'GP' },
  { value: 'gp_trainee', label: 'GP Trainee' },
  { value: 'practice_nurse', label: 'Practice Nurse' },
  { value: 'consultant', label: 'Consultant' },
  { value: 'hospital_doctor', label: 'NCHD (Hospital Doctor)' },
  { value: 'nurse_specialist', label: 'Nurse specialist' }
]

const SignUpForm = ({
  user,
  user: {
    first_name,
    last_name,
    email,
    password,
    email_confirmation,
    user_type
  },
  onFieldChange,
  onSubmit,
  errors = {},
  termsOfService,
  onTermsOfServiceChange,
  roleFields
}) => (
  <div className="container_global_password">
    <h2 className="password_title">CREATE AN ACCOUNT</h2>
    <div className="container_signin row">
      <form className="col s12" onSubmit={onSubmit}>
        <div className="row">
          {
            [{
              field_name: 'first_name',
              value: first_name
            }, {
              field_name: 'last_name',
              value: last_name
            }].map(e => (
              <InputField
                className='col s12 m6'
                label={labels[e.field_name]}
                onChange={onFieldChange}
                errors={errors[e.field_name]}
                autoComplete='new-password'
                {...e}
               />
            ))
          }
          <SelectField
            className='col s12'
            label={labels['user_type']}
            onChange={onFieldChange}
            errors={errors['user_type']}
            autoComplete='new-password'
            field_name='user_type'
            value={user_type}
            options={roles}
          />
          { roleFields.map(field => (
            <InputField
              className='col s12'
              label={labels[field]}
              onChange={onFieldChange}
              errors={errors[field]}
              autoComplete='new-password'
              value={user[field] || ''}
              field_name={field}
            />
            ))}
          {
            [{
              field_name: 'email',
              value: email,
              type: 'email',
              className: 'col s12'
            }, {
              field_name: 'email_confirmation',
              value: email_confirmation,
              type: 'email',
              className: 'col s12'
            }, {
              field_name: 'password',
              value: password,
              type: 'password',
              className: 'col s12'
            }].map(e => (
              <InputField
                className='col s12 m6'
                label={labels[e.field_name]}
                onChange={onFieldChange}
                errors={errors[e.field_name]}
                autoComplete='new-password'
                {...e}
               />
            ))
          }
          <p className="creat_password_text">
            <input type="checkbox" id="checkbox_in"
              onClick={e => onTermsOfServiceChange(e.target.value)}
              value={termsOfService}
            />
            <label htmlFor="checkbox_in">
              <Link to={'/terms_of_service'}>
                I accept the Terms of Service
              </Link>
            </label>
          </p>
          <div className="submit_center col s12">
            <input className="container_password_button" type="submit" name="" value="Sign Up" />
          </div>
        </div>
      </form>
      <p className="container_signin_text" style={{ marginBottom: '15px' }}>
        <Link to="/users/sign_in">
          Already have an account?
        </Link>
      </p>
    </div>
  </div>
)

SignUpForm.propTypes = {
  user: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  errors: PropTypes.array,
}

export default SignUpForm



/** WEBPACK FOOTER **
 ** ./src/components/Authorization/SignUp/SignUpForm.js
 **/